export default __webpack_public_path__ + "static/dataschoolIntro-8d5fe75fcb24d0dec5fca1b9072b0df1.png";